// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';

// utilities

// components
import ProspectForm from '../../../public/ProspectForm';
import ScrollColumn from '../../../../common/components/ScrollColumn';

function AddContact(props) {

  return (
    <div className='admin-content-container'>
      <ScrollColumn
        navGroups={['Contact_Info', 'Company_Info', 'Preliminary_Info', 'Inquiry_Reason']}
        title={'Add New'}
      />
      <ProspectForm asAdmin />
    </div>
  );
}
export default connect()(AddContact);



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Add/index.js